import axios from "axios";
const url = process.env.REACT_APP_BACKEND_URL;

export async function getAllLeagues() {
    return axios({
        method: 'get',
        url: url + "/leagues"
    }).then(res => {
        return res.data;
    });
}

export async function getLeaguesByCategoryId(categoryId) {
    return axios({
        method: 'get',
        url: url + "/leagues?categoryId=" + categoryId
    }).then(res => {
        return res.data;
    });
}


export async function getSingleLeague(leagueId) {
    return axios({
        method: 'get',
        url: url + "/leagues?_id=" + leagueId
    }).then(res => {
        return res.data;
    });
}



export async function makeLeague(
    authToken,
    title,
    logoUrl,
    categoryId) {

    let teams = [];

    return axios.post(url + "/leagues", {
        title,
        logoUrl,
        teams,
        categoryId
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });

}

export async function deleteLeague(
    authToken,
    leagueId) {

    return axios.delete(url + "/leagues",
        {
            data: { leagueId: leagueId },
            headers: { Authorization: `Bearer ${authToken}` }
        })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });
}


// WEBPACK FOOTER //
// ./src/api-calls/leagues.js